import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";


const Privacy = () => {
const navigate = useNavigate();
const [sticky, setSticky] = useState("");
const goToAboutSection = (name) => {
    navigate("/#"+name);
  };
  const classes = `main-header ${sticky} mobhide`;
  useEffect(() => {
        // fetchcourses();
        const handleScroll = () => {
         // sticky header
    
         const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
        setSticky(stickyClass);
        console.log(stickyClass);
       };
    
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
    
      }, []);
  
  return (
    <div className="main-body">
      {/* Terms & condition */}
    <section>
        <div className="termsconditionsmaindiv">
            <div className="container">
                <p className="about-head termsconditionshead">Privacy Policy</p>
                <p className="terms-description">
                    Effective Date: 12th August 2025
                </p>
                <br />
                <p className="termshead">1. Introduction</p>
                <p className="terms-description">This Privacy Policy explains how Mansthal Farming Connection (“we,” “our,” or “us”) collects, uses, discloses, and protects your personal information when you use our Platform.</p>

                <p className="termshead">2. Information We Collect</p>
                <p className="terms-description">
                We may collect: <br />
                a) Personal Information: Name, email address, phone number, location, farming details.<br />
                b) Usage Data: IP address, browser type, device type, pages visited, and interaction data.<br />
                c) Content: Posts, comments, messages, and media you upload.<br />
                </p>

                <p className="termshead">3. How We Use Your Information</p>
                <p className="terms-description">
                We use your data to: <br />
                a) Provide and improve Platform services.<br />
                b) Connect you with other farmers and relevant groups.<br />
                c) Send updates, notifications, and farming-related information.<br />
                d) Comply with legal obligations.
                </p>

                <p className="termshead">4. Data Sharing & Disclosure</p>
                <p className="terms-description">
                a) We do not sell your personal data to third parties.<br />
                b) We may share your data with trusted service providers for Platform functionality.<br />
                c) We may disclose information if required by law or to protect our legal rights.
                </p>

                <p className="termshead">5. Data Retention</p>
                <p className="terms-description">
                We retain personal data only for as long as necessary to fulfill the purposes outlined in this policy or as required by law.
                </p>

                <p className="termshead">6. Data Security</p>
                <p className="terms-description">
                We use encryption, firewalls, and secure servers to protect your information, but we cannot guarantee 100% security due to the nature of the internet.
                </p>

                <p className="termshead">7. Your Rights</p>
                <p className="terms-description">You have the right to: <br />
                a) Access, correct, or delete your personal data.<br />
                b) Withdraw consent at any time.
                c) Request information about how your data is processed.
                </p>

                <p className="termshead">8. Third-Party Links</p>
                <p className="terms-description">Our Platform may contain links to external websites. We are not responsible for their privacy practices or content.</p>

                <p className="termshead">9. Policy Updates</p>
                <p className="terms-description">We may update this Privacy Policy from time to time. Changes will be posted with a revised “Effective Date.”</p>
            </div>
        </div>
    </section>
    </div>
  );
};

export default Privacy;
